import type { Routes } from '@angular/router';
import { ClaimsGuard } from '../../auth/guard/claims.guard';
import {
  AppActions,
  AppFeature,
  getClaimString,
} from '../../shared/constants/app-claims';

export const LANDING_INSPECTION_ROUTES: Routes = [
  {
    path: 'landing-inspection',
    pathMatch: 'full',
    canActivate: [ClaimsGuard],
    data: {
      claims: [getClaimString(AppFeature.InspectionsFids, AppActions.Read)],
    },
    loadComponent: () =>
      import(
        './components/landing-inspection/landing-inspection.component'
      ).then(m => m.LandingInspectionComponent),
  },
  {
    path: 'shark-details',
    canActivate: [ClaimsGuard],
    data: {
      claims: [getClaimString(AppFeature.InspectionsSharks, AppActions.Read)],
    },
    loadComponent: () =>
      import('./components/sharks-details/shark-details.component').then(
        m => m.SharkDetailsComponent
      ),
  },
  {
    path: 'scale-details',
    canActivate: [ClaimsGuard],
    data: {
      claims: [getClaimString(AppFeature.InspectionsScale, AppActions.Read)],
    },
    loadComponent: () =>
      import('./components/scale-details/scale-details.component').then(
        m => m.ScaleDetailsComponent
      ),
  },
  {
    path: '',
    redirectTo: 'landing-inspection',
    pathMatch: 'full',
  },
  {
    path: 'fid-details',
    canActivate: [ClaimsGuard],
    data: {
      claims: [getClaimString(AppFeature.InspectionsFids, AppActions.Read)],
    },
    loadComponent: () =>
      import(
        './components/landing-inspection/pdf-report/pdfLandingInspection/pdf-landing-inspection-main/pdf-landing-inspection-main.component'
      ).then(m => m.PdfLandingInspectionMainComponent),
  },
];
